<ng-container *ngIf="!(Loading$ | async); else loading">
    <mat-card class="card card-container" *ngIf="!Editing">
        <div class="card-header contract">
            <fa-icon class="icon" icon="file-contract"></fa-icon>
            <mat-form-field
                class="search-field"
                floatLabel="never"
                color="primary"
                *ngIf="ContractSearchBarActive; else searchBarInactive"
            >
                <mat-label>Suche nach Verträgen</mat-label>
                <input
                    type="text"
                    [formControl]="ContractSearchForm"
                    (keyup.enter)="SearchContract()"
                    #contractSearchInput
                    matInput
                />
                <button
                    class="clear-search"
                    (click)="ClearContractSearchForm()"
                    mat-icon-button
                    *ngIf="ContractSearchForm.value"
                >
                    <fa-icon icon="times"></fa-icon>
                </button>
            </mat-form-field>

            <ng-template #searchBarInactive>
                <h3>Verträge</h3>
            </ng-template>
            <button
                app-round-button
                class="button"
                [matTooltip]="ContractSearchBarActive && ContractSearchForm.value.length === 0 ? 'Ausblenden' : 'Suche'"
                matTooltipPosition="left"
                (click)="SearchContractButtonClicked()"
            >
                <fa-icon
                    [icon]="ContractSearchBarActive && ContractSearchForm.value.length === 0 ? 'times' : 'search'"
                ></fa-icon>
            </button>
            <button
                app-round-button
                style="margin-left: .5rem"
                [matTooltip]="'Hinzufügen / Entfernen'"
                matTooltipPosition="left"
                (click)="OpenContractSelect$.next()"
            >
                <fa-icon
                    [icon]="'user-cog'"
                ></fa-icon>
            </button>
        </div>

        <!-- CSS-Klasse ist nur für den inset box shadow -->
        <ngx-simplebar class="clickable-list-container" *ngIf="ShownCustomerContractsList$ | async | length; else noContent">
            <mat-nav-list style="max-height: 400px">
                <div mat-line style="margin-top: 0.5rem; font-size: 0.8rem;">
                    <span style="flex: 2; margin-left: 1rem">Teilnahme<br>zeitraum</span>
                    <span style="flex: 1; margin-left: -1rem">Ausnahme<br>datum</span>
                    <span style="flex: 1;">Nummer</span>
                    <span style="flex: 1;">Name</span>
                </div>
                <mat-divider></mat-divider>
                <a
                    mat-list-item
                    [routerLink]="['/', ContractMeta.Path, Contract.id]"
                    *ngFor="let Contract of ShownCustomerContractsList$ | async"
                >

                    <div mat-line>
                        <span style="flex: 2;">{{Contract.date}}</span>
                        <span style="flex: 1;">{{Contract.ausnahmedatum}}</span>
                        <span style="flex: 1;">{{ Contract.number }}</span>
                        <span style="flex: 1;">{{ Contract.name }}</span>
                    </div>

                    <mat-divider></mat-divider>
                </a>
            </mat-nav-list>
        </ngx-simplebar>
    </mat-card>
    <mat-card class="card" *ngIf="Editing">
        <div class="card-header contract">
            <fa-icon class="icon" icon="file-contract"></fa-icon>
            <mat-form-field
                class="search-field"
                floatLabel="never"
                color="primary"
                *ngIf="ContractSearchBarActive; else searchBarInactive"
            >
                <mat-label>Suche nach Verträgen</mat-label>
                <input
                    type="text"
                    [formControl]="ContractSearchForm"
                    (keyup.enter)="SearchContract()"
                    #contractSearchInputEdit
                    matInput
                />
                <button
                    class="clear-search"
                    (click)="ClearContractSearchForm()"
                    mat-icon-button
                    *ngIf="ContractSearchForm.value"
                >
                    <fa-icon icon="times"></fa-icon>
                </button>
            </mat-form-field>

            <ng-template #searchBarInactive>
                <h3>Verträge</h3>
            </ng-template>
            <button
                app-round-button
                class="button"
                [matTooltip]="ContractSearchBarActive && ContractSearchForm.value.length === 0 ? 'Ausblenden' : 'Suche'"
                matTooltipPosition="left"
                (click)="SearchContractButtonClicked()"
                Inverted
            >
                <fa-icon [icon]="ContractSearchBarActive && ContractSearchForm.value.length === 0 ? 'times' : 'search'"></fa-icon>
            </button>
        </div>
        <!-- CSS-Klasse ist nur für den inset box shadow -->
        <ngx-simplebar class="clickable-list-container" *ngIf="ShownAllContractsList; else noContent">
            <mat-action-list style="max-height: 400px">
                <button
                    mat-list-item
                    *ngFor="let Contract of ShownAllContractsList"
                    (click)="EditContractList(Contract)"
                >
                    <div mat-line>
                        <span>{{ Contract.Number }}</span>
                        <span>{{ Contract.Name }}</span>
                        <span style="text-align: end">
                            <fa-icon icon="check-circle" class="primary" *ngIf="GreenCheck(Contract.Id)"></fa-icon>
                            <fa-icon
                                icon="check-circle"
                                style="color: #03a9f4"
                                *ngIf="BlueCheck(Contract.Id)"
                            ></fa-icon>
                        </span>
                    </div>

                    <mat-divider></mat-divider>
                </button>
            </mat-action-list>
        </ngx-simplebar>
    </mat-card>
</ng-container>

<ng-template #loading>
    <app-loading></app-loading>
</ng-template>

<ng-template #noContent>
    <table class="clickable-list-container">
        <tr>
            <td class="empty-table-text">Keine Verträge vorhanden</td>
        </tr>
    </table>
</ng-template>
